/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used in labels.
 */
export const DASHBOARD_SUMMARY_STRINGS = {
  lastXDays: `Last {{count}} days`,
  vsPreviousXDays: `vs previous {{count}} {{period}}`,
};
